const encoding = require('encoding-japanese');
export default {
  fullWidth: value => {
    let a = encoding.convert(value, {
      to: 'SJIS',
      type: 'array'
    });
    for (var i = 0; i < a.length; i++) {
      let firstByte = Number(a[i]);
      if (firstByte <= 0x7f || firstByte >= 0xa1 && firstByte <= 0xdf) {
        return false;
      }
      i++;
      let secondByte = Number(a[i]);
      let mCode = Number(firstByte << 8 | secondByte);
      if (mCode >= 0x8140 && mCode <= 0x84be) {} else if (mCode >= 0x889f && mCode <= 0x9872) {} else if (mCode >= 0x989f && mCode <= 0xeaa4) {
        // } else if ((mCode >= 0xfa40) && (mCode <= 0xfc4b)) {
      } else if (mCode >= 0x8754 && mCode <= 0x875d) {} else if (mCode == 0x8782) {} else if (mCode == 0x8784) {} else if (mCode == 0x878a) {} else if (mCode >= 0xed40 && mCode <= 0xeefc) {} else {
        return false;
      }
    }
    return true;
  },
  fullKana: value => {
    let a = encoding.convert(value, {
      to: 'SJIS',
      type: 'array'
    });
    for (var i = 0; i < a.length; i++) {
      let firstByte = Number(a[i]);
      if (firstByte <= 0x7f || firstByte >= 0xa1 && firstByte <= 0xdf) {
        return false;
      }
      i++;
      let secondByte = Number(a[i]);
      let mCode = Number(firstByte << 8 | secondByte);
      if (mCode >= 0x8340 && mCode <= 0x8396) {} else if (mCode == 0x8145) {} else {
        return false;
      }
    }
    return true;
  }
};